var map = {
	"./banner_gamardzhoba-big.JPG": 1092,
	"./banner_gamardzhoba.JPG": 1093,
	"./banner_jpan.jpg": 1094,
	"./banner_kook.png": 974,
	"./banner_league.jpg": 1095,
	"./banner_mistral.jpg": 975,
	"./banner_nanirestaurant-big.JPG": 1096,
	"./banner_nanirestaurant.JPG": 1097,
	"./banner_oae.jpg": 1098,
	"./banner_ramen_2.png": 976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;